import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/simpleinvoice.jpeg';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import downIcon from '../images/download.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import { data } from "react-router";
import CustomerDiv from "../common/customerdiv";
import DatePicker from "react-datepicker";
import { getDayWiseAmount } from "../common/mylib";
const PendingInvoices=()=>
{
const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [paymentdata,setPaymentData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({
        facilityid:0,
        facilityname: "",
        subscriberid: "",
        subscribername: "",
        subscribercompany: "",
        subscriptionid: "",
        planid: 0,
        planname: "N",
        planstartdate: "",
        planenddate: "",
        amount: "",
        gstinvoice: "",
        billstartdate: "",
        billenddate: "",
        camount:0,
    });
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });
    const columns = [
        { name: "Facility", key: "facilityname", sortable: true},
        { name: "Customer", key: "subscribername", sortable: true },
        { name: "Company", key: "subscribercompany", sortable: true },
        { name: "Plan", key: "planname", sortable: true },
        { name: "Start Date", key: "planstartdate", sortable: true },
        { name: "End Date", key: "planenddate", sortable: true },
        { name: "Next Due Date", key: "billstartdate", sortable: true },
        { name: "GST", key: "gstinvoice", sortable: true },
        { name: "Amount", key: "amount", sortable: true },
    ];
    function addSubsriber(event)
    {
        setFormData({
        facilityid:0,
        facilityname: "",
        subscriberid: "",
        subscribername: "",
        subscribercompany: "",
        subscriptionid: "",
        planid: 0,
        planname: "N",
        planstartdate: "",
        planenddate: "",
        amount: "",
        gstinvoice: "",
        billstartdate: "",
        billenddate: "",
        camount:0,
        });
        setShow(true);
    }
    async function saveData(event)
    {
        setMsg("");
        if(window.confirm('Are you sure?'))
        {
            let d=new Date().toISOString().split("T")[0];

            let billdata={subscriberid:formData.subscriberid,subscriptionid:formData.subscriptionid,facilityid:formData.facilityid,billdate:d,billfrom:formData.billstartdate,billto:formData.billenddate,billdetails:formData.planname,billamount:formData.camount,isgst:formData.gstinvoice,sgstrate:0,cgstrate:0,igstrate:0,billtotal:formData.camount};
            //console.log(billdata);
            //console.log(formData);  
            
            setProgress(true);
            await apiClient.post("/api/invoice/CreateInvoice/",billdata).then(reply=>
                {
                if(reply.status==200)
                {
                    console.log(reply.data);
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadTransactions();
                        setFormData({facilityid:0,facilityname: "",subscriberid: 0,subscribername: "",subscribercompany: "",subscriptionid: 0,planid: 0,planname:"",planstartdate:"",planenddate:"",amount:0,gstinvoice:"N",billstartdate:"",billenddate:"",camount:0,}   );
                        setShow(false);
                        if(billdata.isgst=="Y")
                            window.open(process.env.REACT_APP_APIURL+"/api/Download/Tax/"+reply.data.data.id,"","width=600,height:800");
                        else
                            window.open(process.env.REACT_APP_APIURL+"/api/Download/Simple/"+reply.data.data.id,"","width=600,height:800");
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");
                    }
                }
                });
            setProgress(false);
                
        }

    }
    async function loadTransactions()
    {
        //console.log("Token:",localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/invoice/GetNextInvoiceDetails").then(res=>
        {
            if(res.status==200)
            {
                setPaymentData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                setTotalPage(Math.ceil(res.data.data.length/pageSize));
            }
        });
        setProgress(false);
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>=3)
            {
                let searchResult=paymentdata.filter((e)=>e.facilityname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.subscribername.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.subscribercompany.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.planname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(paymentdata);
                setPageData(paymentdata.slice(0,pageSize));
            }
            setPage(1);
        }
    }    
    function dateChange(event)
    {
        if(event.target.id=="billstartdate")
        {
            let amt=getDayWiseAmount(formData.amount,event.target.value,formData.billenddate);
            setFormData({...formData,billstartdate:event.target.value,camount:amt});
        }
        if(event.target.id=="billenddate")
        {
            let amt=getDayWiseAmount(formData.amount,formData.billstartdate,event.target.value);
            setFormData({...formData,billenddate:event.target.value,camount:amt});
        }

    }
    function formValueChanged(event)
    {
        //{facilityid:0,facilityname: "",subscriberid: 0,subscribername: "",subscribercompany: "",subscriptionid: 0,planid: 0,planname:"",planstartdate:"",planenddate:"",amount:0,gstinvoice:"N",billstartdate:"",billenddate:""}
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});

        if(event.target.id=="billdetails") setFormData({...formData,state:event.target.value});

        if(event.target.id=="billamount")
        {
            let net=calculateTotal(event.target.value,formData.sgstrate,formData.cgstrate,formData.igstrate);
            setFormData({...formData,billamount:event.target.value,totalamt:net});
        }
        if(event.target.id=="sgstrate")
        {
            let net=calculateTotal(formData.billamount,event.target.value,formData.cgstrate,formData.igstrate);
            setFormData({...formData,sgstrate:event.target.value,totalamt:net});
        }
        if(event.target.id=="cgstrate")
        {
            let net=calculateTotal(formData.billamount,formData.sgstrate,event.target.value,formData.igstrate);
            setFormData({...formData,cgstrate:event.target.value,totalamt:net});
        }
        if(event.target.id=="igstrate")
        {
            let net=calculateTotal(formData.billamount,formData.cgstrate,formData.sgstrate,event.target.value,);
            setFormData({...formData,igstrate:event.target.value,totalamt:net});
        }
    }
    function calculateTotal(amt,sgst,cgst,igst)
    {
        return Math.round(parseFloat(amt)+ (parseFloat(amt)*parseFloat(sgst)+parseFloat(cgst)+parseFloat(igst)));
    }
    function deleteInvoice(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Invoice/DeleteSimpleInvoice/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadTransactions();
                }
            });
        }
    }
    async function editInvoice(idx)
    {
        let obj=pageData[idx];
        let d=new Date(obj.billstartdate.split("-").reverse().join("-"));
        d.setMonth(d.getMonth()+1);
        d.setDate(d.getDate()-1);
        setFormData({...obj,billstartdate:obj.billstartdate.split("-").reverse().join("-"),billenddate:d.toISOString().split("T")[0],camount:obj.amount});
        setShow(true);
    }
    function downloadInvoice(id)
    {
        apiClient.get(process.env.REACT_APP_APIURL+"/api/DownloadInvoice/Simple/"+id).then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                setFormData(res.data.data);
                setShow(true);
            }
        });
    }
    function sortData(colname)
    {
        if(colname=="facilityname" || colname=="subscribername"|| colname=="subscribercompany"|| colname=="planname"|| colname=="gstinvoice")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1.partyname.trim().toLowerCase()>e2.partyname.trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );
            setDataToDisplay(arr);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="planstartdate" || colname=="planenddate")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="amount")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
    }
    function getLastDayOfMonth(dateStr)
    {
        const [dd, mm, yyyy] = dateStr.split('-').map(Number);
        // Month in JS Date is 0-based
        let dt=new Date(yyyy, mm, 0).toISOString().split("T")[0].split("-").reverse().join("-");
        //console.log("Date="+dt);
        return dt;
    }
    function numberToWords(num)
    {
        if (num === 0) return "Zero Only";
        if (num >= 10000000) return "Amount exceeds limit";

        const ones = [
            "", "One", "Two", "Three", "Four", "Five",
            "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen",
            "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];

        const tens = [
            "", "", "Twenty", "Thirty", "Forty",
            "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
        ];

        function twoDigits(n) {
            if (n < 20) return ones[n];
            return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        }

        function threeDigits(n) {
            let str = "";
            if (n >= 100) {
                str += ones[Math.floor(n / 100)] + " Hundred";
                if (n % 100) str += " and ";
            }
            str += twoDigits(n % 100);
            return str.trim();
        }

        let result = "";
        let lakh = Math.floor(num / 100000);
        let thousand = Math.floor((num % 100000) / 1000);
        let hundred = num % 1000;

        if (lakh) result += twoDigits(lakh) + " Lakh ";
        if (thousand) result += twoDigits(thousand) + " Thousand ";
        if (hundred) result += threeDigits(hundred);

        return result.trim() + " Only";
    }
    function getRound(num)
    {
        return Math.round(num*100)/100;
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;
        showPage(p);
    }
    useEffect(()=>{
        loadTransactions();
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" placeholder="Facility/Customer Name/ Company/ Details...." id="searchText" style={{fontSize:'12px',width:'250px'}} onChange={searchData} className="form-control" /></div>
                <div className="flex-grow-1 text-end">

                </div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Next Pending Invoice Details</div>
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>
                                <th key={i}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>
                            )}
                            <th>View/Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={i}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                {
                                    if(ee.key=="billstartdate")
                                    {
                                        return(<td className="table-success fw-bold">{e.billstartdate}</td>);
                                    }
                                    else if(ee.key=="amount")
                                    {
                                        return(<td className={e.gstinvoice=="Y"?"table-info":"table-danger"}>{getRound(e[ee.key])}</td>);
                                    }
                                    else
                                    {
                                        return(<td className={e.gstinvoice=="Y"?"table-info":"table-danger"}>{e[ee.key]}</td>);
                                    }
                                }
                                )}
                                <td className="text-center"><img onClick={()=>editInvoice(i)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="1"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="9" className="text-end">
                            </th>
                            <th colSpan="1" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="11">Total {dataToDisplay.length} Entries</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-lg" >
                            <div className="modal-content rounded" style={{border:'double 1px black', boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center">{formData.gstinvoice=="Y"?"Tax Invoice":"Simple Invoice"}</div>
                                    <div className="text-end"><b>Date: </b> {new Date().toISOString().split("T")[0].split("-").reverse().join("-")}</div>
                                    <div className="fw-bold">{formData.subscribername}</div>
                                    <div>{formData.subscribercompany}</div>
                                    <div className="p-2 border rounded">
                                        <div className="d-flex">
                                            <div className="form-control">
                                                <label>Plan Details</label>
                                                <input type="text" value={formData.planname} className="form-control form-control-sm" />
                                            </div>
                                            <div className="form-control">
                                                <label>From</label>
                                                <input type="date" id="billstartdate"  onChange={dateChange} value={formData.billstartdate} className="form-control" />
                                            </div>
                                            <div className="form-control">
                                                <label>To</label>
                                                <input type="date" id="billenddate" onChange={dateChange} value={formData.billenddate} className="form-control" />
                                            </div>
                                            <div className="form-control">
                                                <label>Amount</label>
                                                <input type="text" value={getRound(formData.amount)} className="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        {formData.gstinvoice=="Y" &&(
                                            <div className="border rounded p-2">
                                                <div className="text-end fw-bold">Amount: &#8377; {getRound(formData.camount)}</div>
                                                <div className="text-end fw-bold">CGST (9%): &#8377; {getRound(formData.camount*.09)}</div>
                                                <div className="text-end fw-bold">SGST (9%): &#8377; {getRound(formData.camount*.09)}</div>
                                                <div className="text-end fw-bold">IGST (18%): &#8377; 0.00</div>
                                                <div className="text-end fw-bold">Net Payable: &#8377; {Math.round(formData.camount*.18+formData.camount)}</div>
                                                <div>Amount in Words</div>
                                                <div className="fw-bold">{numberToWords(Math.round(formData.camount*.18+formData.camount))}</div>
                                            </div>
                                        )}
                                        {formData.gstinvoice=="N" &&(
                                            <div className="border rounded p-2">
                                                <div className="text-end fw-bold">Net Payable: &#8377; {Math.round(formData.camount)}</div>
                                                <div>Amount in Words</div>
                                                <div className="fw-bold">{numberToWords(Math.round(formData.camount))}</div>
                                            </div>
                                        )}
                                    </div>
                                    <input type="button" className="btn btn-danger"  onClick={saveData} value="Create Invoice" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>
                        </div>
                    </div>
                )}
        </div>
    );
}
export default PendingInvoices;